import perms from './middleware/permission';
import type { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('../layouts/MainLayout.vue');

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'dashboard',
    component: MainLayout,
    meta: { title: 'Oversigt' },
    /*beforeEnter: (to, from, next) => {
      perms(['dashboard'], to, from, next);
    },*/
    children: [{ path: '/', component: () => import('../pages/Index.vue') }],
  },
  {
    path: '/scan',
    name: 'scan',
    component: MainLayout,
    meta: { title: 'Udlevering' },
    beforeEnter: (to, from, next) => {
      perms(['scan'], to, from, next);
    },
    children: [{ path: '/scan', component: () => import('../pages/scan/Index.vue') }],
  },
  {
    path: '/stock',
    name: 'stock',
    component: MainLayout,
    meta: { title: 'Lager' },
    beforeEnter: (to, from, next) => {
      perms(['stock'], to, from, next);
    },
    children: [
      { path: '/stock', component: () => import('../pages/stock/Index.vue') },
      { path: 'roles', component: () => import('../pages/stock/RoleSetup.vue') },
      { path: ':uuid', component: () => import('../pages/stock/Item.vue') },
    ],
  },
  {
    path: '/orders',
    name: 'orders',
    meta: { title: 'Ordre' },
    component: MainLayout,
    children: [
      { path: '/orders', component: () => import('../pages/orders/Index.vue') },
      {
        path: ':uuid/view',
        component: () => import('../pages/orders/View.vue'),
      },
      {
        beforeEnter: (to, from, next) => {
          perms(['orders'], to, from, next);
        },
        path: ':uuid/packing',
        component: () => import('../pages/orders/Packing.vue'),
      },
      { path: ':uuid', component: () => import('../pages/orders/Edit.vue') },
    ],
  },
  {
    path: '/shop',
    name: 'shop',
    meta: { title: 'Webshop' },
    component: MainLayout,
    beforeEnter: (to, from, next) => {
      perms(['shop'], to, from, next);
    },
    children: [
      { path: '/shop', component: () => import('../pages/shop/Index.vue') },
      { path: 'cart', component: () => import('../pages/shop/Index.vue') },
      { path: 'favorites', component: () => import('../pages/shop/Index.vue') },
      { path: 'orders', component: () => import('../pages/shop/Orders.vue') },
    ],
  },
  {
    path: '/purchasing',
    name: 'purchasing',
    component: MainLayout,
    meta: { title: 'Indkøb' },
    beforeEnter: (to, from, next) => {
      perms(['purchasing'], to, from, next);
    },
    children: [
      { path: '/purchasing', component: () => import('../pages/purchasing/Index.vue') },
      /*{
        path: "create",
        component: () => import("pages/purchasing/Create.vue"),
      },*/
      {
        path: ':uuid',
        component: () => import('../pages/purchasing/Edit.vue'),
      },
    ],
  },
  {
    path: '/reception',
    name: 'reception',
    component: MainLayout,
    meta: { title: 'Varemodtagelse' },
    beforeEnter: (to, from, next) => {
      perms(['reception'], to, from, next);
    },
    children: [{ path: '/reception', component: () => import('../pages/reception/Index.vue') }],
  },
  {
    path: '/settings',
    name: 'settings',
    meta: { title: 'Indstillinger' },
    component: MainLayout,
    children: [
      { path: '/settings', component: () => import('../pages/settings/Index.vue') },
      {
        beforeEnter: (to, from, next) => {
          perms(['settings'], to, from, next);
        },
        path: 'users',
        component: () => import('../pages/settings/Users.vue'),
      },
      {
        path: 'select-warehouse',
        component: () => import('../pages/settings/SelectWarehouse.vue'),
      },
      {
        beforeEnter: (to, from, next) => {
          perms(['settings'], to, from, next);
        },
        path: 'warehouses',
        component: () => import('../pages/settings/Warehouses.vue'),
      },
      {
        beforeEnter: (to, from, next) => {
          perms(['settings'], to, from, next);
        },
        path: 'suppliers',
        component: () => import('../pages/settings/Suppliers.vue'),
      },
      {
        beforeEnter: (to, from, next) => {
          perms(['settings'], to, from, next);
        },
        path: 'manufacturer',
        component: () => import('../pages/settings/Manufacturer.vue'),
      },
      {
        path: 'account',
        component: () => import('../pages/settings/Account.vue'),
      },
      {
        beforeEnter: (to, from, next) => {
          perms(['settings'], to, from, next);
        },
        path: 'customers',
        component: () => import('../pages/settings/Customers.vue'),
      },
      {
        beforeEnter: (to, from, next) => {
          perms(['settings'], to, from, next);
        },
        path: 'roles',
        component: () => import('../pages/settings/Roles.vue'),
      },
      {
        beforeEnter: (to, from, next) => {
          perms(['settings'], to, from, next);
        },
        path: 'tags',
        component: () => import('../pages/settings/Tags.vue'),
      },
      {
        beforeEnter: (to, from, next) => {
          perms(['settings'], to, from, next);
        },
        path: 'sectors',
        component: () => import('../pages/settings/Sectors.vue'),
      },
      {
        beforeEnter: (to, from, next) => {
          perms(['settings'], to, from, next);
        },
        path: 'stats',
        component: () => import('../pages/settings/Stats.vue'),
      },
      {
        path: 'scanner-test',
        component: () => import('../pages/settings/ScannerTest.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: 'Login' },
    component: () => import('../layouts/LoginLayout.vue'),
    children: [{ path: '/login', component: () => import('../pages/login/IndexPage.vue') }],
  },
  {
    path: '/loginad',
    name: 'loginad',
    meta: { title: 'Login AD' },
    component: () => import('../layouts/LoginLayout.vue'),
    children: [{ path: '/loginad', component: () => import('../pages/login/LoginAD.vue') }],
  },
  {
    path: '/loginexternal',
    name: 'loginexternal',
    meta: { title: 'Ekstern login' },
    component: () => import('../layouts/LoginLayout.vue'),
    children: [{ path: '/loginexternal', component: () => import('../pages/login/LoginExternal.vue') }],
  },
  {
    path: '/noaccess',
    name: 'Error403Page',
    meta: { title: '403' },
    component: () => import('../pages/Error403Page.vue'),
  },
  {
    path: '/:catchAll(.*)*',
    name: 'Error404Page',
    meta: { title: '404' },
    component: () => import('../pages/Error404Page.vue'),
  },
];

export default routes;
